






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapMutations } from 'vuex';

@Component
export default class Modal extends Vue {
  private isVisible: boolean = false;

  @Prop({ type: String, required: true }) private name!: string;
  @Prop({ type: Number, required: false, default: 300 }) private delay!: number;
  @Prop({ type: Number, required: false }) private width!: number;

  private get style(): string | boolean {
    return this.width ? `width: ${this.width}px` : false;
  }

  private setOverlay(state: boolean): void {
    this.$store.commit('ui/setOverlay', state);
  }

  private toggle(state: boolean): void {
    this.isVisible = state;
    state ? this.setOverlay(state) : setTimeout(() => this.setOverlay(state), this.delay);
  }

  private close() {
    this.toggle(false);
  }

  private beforeMount(): void {
    this.$bus.$on('modal-toggle', (name: string, state: boolean, params: any) => {
      if (name === this.name) {
        state = typeof state === 'undefined' ? !this.isVisible : state;
        this.toggle(state);
      }
    });

    this.$bus.$on('modal-show', (name: string, state: boolean, params: any) => {
      return name === this.name ? this.toggle(true) : false;
    });

    this.$bus.$on('modal-hide', (name: string, state: boolean, params: any) => {
      return name === this.name ? this.toggle(false) : false;
    });
  }

  private mounted(): void {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.close();
      }
    };

    document.addEventListener('keydown', handler);

    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', handler);
    });
  }
}
